import React, { useEffect } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import './Privacy.css';

function Privacy() {
  useEffect(() => {
    // Animation for sections appearing on scroll
    const sections = document.querySelectorAll('.privacy-section');
    
    const observerOptions = {
      threshold: 0.1,
      rootMargin: "0px 0px -50px 0px"
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('appear');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);
    
    sections.forEach(section => {
      observer.observe(section);
    });
    
    return () => {
      sections.forEach(section => {
        observer.unobserve(section);
      });
    };
  }, []);

  return (
    <div className="privacy-container">
      <Header />
      
      <div className="privacy-hero">
        <h1 className="privacy-title">Protection de votre confidentialité</h1>
        <p className="privacy-subtitle">Dernière mise à jour : 11 mars 2025</p>
      </div>
      
      <div className="privacy-content">
        <div className="privacy-section">
          <h2>Notre engagement envers vous</h2>
          <p>
            Chez InstalLoc, nous considérons votre vie privée comme un droit fondamental. 
            Notre approche est fondée sur la transparence et le respect, vous donnant 
            toujours le contrôle sur vos informations personnelles, tout au long de votre experience avec notre WoodyBooth.
          </p>
        </div>
        
        <div className="privacy-section">
          <h2>Informations que nous recueillons</h2>
          <div className="privacy-data-items">
            <div className="privacy-data-item">
              <div className="privacy-icon">👤</div>
              <p>Votre identité</p>
              <p className="privacy-details">Nom et prénom</p>
            </div>
            <div className="privacy-data-item">
              <div className="privacy-icon">✉️</div>
              <p>Vos coordonnées</p>
              <p className="privacy-details">Adresse e-mail et téléphone</p>
            </div>
            <div className="privacy-data-item">
              <div className="privacy-icon">🌐</div>
              <p>Sécurité</p>
              <p className="privacy-details">Informations de navigation (adresse IP, navigateur)</p>
            </div>
          </div>
        </div>
        
        <div className="privacy-section">
          <h2>Comment nous utilisons vos données</h2>
          <div className="privacy-use-case">
            <h3>Amélioration continue</h3>
            <p>Nous analysons l'utilisation de nos services pour vous offrir une expérience WoodyBooth toujours plus intuitive et pertinente.</p>
          </div>
          <div className="privacy-use-case">
            <h3>Communication personnalisée</h3>
            <p>Nous répondons à vos questions et vous tenons informé des nouveautés WoodyBooth pour vos évènements.</p>
          </div>
          <div className="privacy-use-case">
            <h3>Offres sur mesure</h3>
            <p>Avec votre consentement, nous vous partageons des opportunités adaptées à vos besoins spécifiques pour tout type d'évènement.</p>
          </div>
        </div>
        
        <div className="privacy-section">
          <h2>Sécurité de vos informations</h2>
          <p>
            Votre confiance est notre priorité. Nous mettons en œuvre des protocoles 
            de sécurité avancés pour protéger vos données contre tout accès non autorisé 
            ou toute utilisation inappropriée.
          </p>
          <p>
            Bien qu'aucune méthode ne soit infaillible, nous révisons régulièrement 
            nos pratiques pour maintenir les plus hauts standards de protection.
          </p>
        </div>
        
        <div className="privacy-section">
          <h2>Partage limité</h2>
          <p>
            Vos informations personnelles restent confidentielles. Nous les partageons 
            uniquement lorsque c'est indispensable à la fourniture de nos services ou 
            lorsque la loi nous y oblige.
          </p>
        </div>
        
        <div className="privacy-section">
          <h2>Cookies et technologies similaires</h2>
          <p>
            Pour vous offrir une expérience fluide et personnalisée, nous utilisons des 
            cookies. Vous gardez le contrôle et pouvez les gérer à tout moment via les 
            paramètres de votre navigateur.
          </p>
        </div>
        
        <div className="privacy-section">
          <h2>Vos droits</h2>
          <div className="privacy-rights">
            <div className="privacy-right">
              <h3>Accès</h3>
              <p>Consultez vos données</p>
            </div>
            <div className="privacy-right">
              <h3>Rectification</h3>
              <p>Corrigez vos informations</p>
            </div>
            <div className="privacy-right">
              <h3>Effacement</h3>
              <p>Supprimez vos données</p>
            </div>
            <div className="privacy-right">
              <h3>Limitation</h3>
              <p>Restreignez l'utilisation</p>
            </div>
          </div>
          <p className="privacy-contact">
            Pour exercer ces droits, contactez-nous à{" "}
            <a href="mailto:contact@instaloc.fr" className="privacy-link">
              contact@instaloc.fr
            </a>
          </p>
        </div>
        
        <div className="privacy-section">
          <h2>Évolution de notre politique</h2>
          <p>
            Notre politique de confidentialité peut évoluer pour refléter les changements 
            de nos pratiques ou de la réglementation. Toute modification sera publiée sur 
            cette page, avec la date de mise à jour correspondante.
          </p>
        </div>
        
        <div className="privacy-section">
          <h2>Restons en contact</h2>
          <p>
            Votre avis compte. Pour toute question ou préoccupation concernant vos données, 
            n'hésitez pas à nous écrire à{" "}
            <a href="mailto:contact@instaloc.fr" className="privacy-link">
              contact@instaloc.fr
            </a>
          </p>
        </div>
      </div>
      
      <Footer />
    </div>
  );
}

export default Privacy;